import {makeAutoObservable} from "mobx";
import * as ComboProvider from '../../services/combo';
import * as PubSub from '../pubSub';
import {Manager} from "../../core";
import {PlanStore} from "../plan/planStore";
import {BATHROOM, BEDROOM, EditRoomsComboProps, EditTimeComboProps, MIDDLE, UpdateItemComboProps} from "../../models";
import {AccountStore} from "../account/accountStore";

export class ComboStoreMobx {
	public list: any[] = [];
	public combo: any;
	public extras: number = 0;
	constructor() {
		makeAutoObservable(this);
	}


	get = async () => {
		try {
			const {data}: any = await ComboProvider.get();
			this.setComboList(data);
			return data;
		} catch (err) {
			throw new Manager.ServiceError('error.comboStore.get', err);
		}
	}

	save = async () => {
		try {
			PlanStore().setPlan({value: PlanStore().getPlanValue()});
			const {data}: any = await ComboProvider.post(PlanStore().plan);
			return data;
		} catch (err) {
			throw new Manager.ServiceError('error.comboStore.save', err);
		}
	}

	editTime = async (payload: EditTimeComboProps): Promise<boolean> => {
		const props: EditTimeComboProps = {
			...payload,
			id: this.combo?.id,
			userId: AccountStore().getUserId()
		};
		try {
			await ComboProvider.editTime(props);
			PubSub.publish('LOAD_COMBO_LIST');
			this.setCombo({...props});
			return true;
		} catch (err) {
			throw new Manager.ServiceError('error.comboStore.editTime', err);
		}
	}

	editRooms = async (payload: EditRoomsComboProps): Promise<boolean> => {
		const props: EditRoomsComboProps = {
			...payload,
			id: this.combo?.id,
			userId: AccountStore().getUserId(),
			value: this.getComboValue(payload),
		};
		try {
			this.setCombo({...props});
			await ComboProvider.editRooms(props);
			PubSub.publish('LOAD_COMBO_LIST');
			return true;
		} catch (err) {
			throw new Manager.ServiceError('error.comboStore.editRooms', err);
		}
	}

	update = async (payload: any): Promise<boolean> => {
		const props: UpdateItemComboProps = {
			id: this.combo?.id,
			userId: AccountStore().getUserId(),
			property: "often",
			value: payload.often,
		};
		try {
			await ComboProvider.update(props);
			PubSub.publish('LOAD_COMBO_LIST');
			this.setCombo({often: payload.often});
			return true;
		} catch (err) {
			throw new Manager.ServiceError('error.comboStore.update', err);
		}
	}

	cancel = async (): Promise<boolean> => {
		const CANCELED = "CANCELED";
		const props: UpdateItemComboProps = {
			id: this.combo?.id,
			userId: AccountStore().getUserId(),
			property: "status",
			value: CANCELED,
		};
		try {
			await ComboProvider.update(props);
			PubSub.publish('LOAD_COMBO_LIST');
			this.setCombo({status: CANCELED});
			return true;
		} catch (err) {
			throw new Manager.ServiceError('error.comboStore.cancel', err);
		}
	}

	setCombo = (item?: any) => {
		const userId = AccountStore().getUserId();
		this.combo = {
			...this.combo,
			userId,
			...item,
		};
	}

	setTotalCombosValue = () => {
		let total = 0;
		const now = new Date();
		const currentMonth = now.getMonth();
		const currentYear = now.getFullYear();

		this.list.forEach(e => {
			if (String(e.status).toUpperCase() === 'ACTIVE' && e.date) {
				const parts = String(e.date).split(/[-/ T]/);
				if (parts.length >= 3) {
					// Assumindo formato YYYY/MM/DD ou YYYY-MM-DD
					const year = parseInt(parts[0], 10);
					const month = parseInt(parts[1], 10) - 1;
					
					if (year === currentYear && month === currentMonth) {
						total += Number(e.value);
					}
				}
			}
		});
		return String(total.toFixed(2));
	}

	setActiveContracts = () => {
		let count = 0;
		this.list.forEach(e => {
			if (String(e.status).toUpperCase() === 'ACTIVE'){
				count += 1
			}
		});
		return String(count | 0);
	}

	setComboDetail = (combo: any) => {
		this.combo = combo;
	}

	setComboList = (list: any) => {
		this.list = list;
	}

	getComboValue = (payload: EditRoomsComboProps) => {
		const { bathrooms, bedrooms, middle } = payload;
		const { plan } = this.combo;
		let countBathrooms, countBedrooms, countMiddle;

		countBathrooms = bathrooms! > 0 ? (bathrooms! - 1) * BATHROOM : 0;
		countBedrooms = bedrooms! > 0 ? (bedrooms! - 1) * BEDROOM : 0;
		countMiddle = middle! > 0 ?  (middle! - 1) * MIDDLE : 0;

		return String(PlanStore().getValue(plan) + Number(countBathrooms + countBedrooms + countMiddle));
	}

}

let singleton: ComboStoreMobx | null;

export const ComboStore = () => {
	if (!singleton) {
		singleton = new ComboStoreMobx();

		PubSub.subscribe(PubSub.LOGOUT, () => {
			singleton = null;
		});
	}
	return singleton;
};
